import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useDispatch } from 'react-redux';
import MainLayout from '../../../../commons/layout/MainLayout/index';
import HeaderHs2 from '../../../../commons/components/Header/headerHs2';
import DialogComponent from '../../../../commons/components/Modal/DialogComponent';
import TabsComponent from '../../../../commons/components/Tabs/TabsComponent';
import API, { ROUTES } from '../../../../commons/api/api';
import { formatPhoneNumber } from '../../../../utils/helpers';

import ROUTERS from '../../../../commons/constans/router';
import { isAndroid, isIOS } from 'react-device-detect';
import './_styles.scss';
import { SOCIAL_LINK } from '../../../../commons/constans/fogotSocial';

import { ReactComponent as LoginApple } from '../../../../assets/images/login_apple.svg'
import { ReactComponent as LoginNaver } from '../../../../assets/images/login_naver.svg'
import { ReactComponent as LoginKakao } from '../../../../assets/images/login_kakao.svg'
import { ReactComponent as LoginGmail } from '../../../../assets/images/login_gmail.svg'

const ForgotPasswordComponent = ({}: Props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [buttonSubmit, setButtonSubmit] = useState(true);

  const [tabIndex, setTabIndex] = useState(0);
  const [dialogNotice, setDialogNotice] = useState({
    show: false,
    content: '',
  });

  const [dataFindEmail, setDataFindEmail] = useState({
    name: '',
    phone: '',
  });

  const [errorFindEmail, setErrorFindEmail] = useState({});

  const [errorFindPassword, setErrorFindPassword] = useState({});

  const [dataFindPassword, setDataFindPassword] = useState({
    name: '',
    phone: '',
    email: '',
  });

  const [redirectToLogin, setRedirectToLogin] = useState(false);

  useEffect(() => {}, []);

  const _onChangeInputFindEmail = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    if (name === 'phone') {
      let valuePhoneNumber = value;
      valuePhoneNumber = value.replaceAll('-', '');
      if (valuePhoneNumber.length <= 11) {
        const re = /^[0-9\b]+$/;
        if (valuePhoneNumber === '' || re.test(valuePhoneNumber)) {
          setDataFindEmail({
            ...dataFindEmail,
            [name]: formatPhoneNumber(valuePhoneNumber),
          });
        }
      }
      return false;
    }

    setDataFindEmail({
      ...dataFindEmail,
      [name]: value,
    });
  };

  const _onChangeInputFindPassword = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const nameFindPassword = target.name;
    var name = '';
    switch (nameFindPassword) {
      case 'find_password_name':
        name = 'name';
        break;
      case 'find_password_phone':
        name = 'phone';
        break;
      case 'find_password_email':
        name = 'email';
        break;
    }

    if (name === 'phone') {
      let valuePhoneNumber = value;
      valuePhoneNumber = value.replaceAll('-', '');
      if (valuePhoneNumber.length <= 11) {
        const re = /^[0-9\b]+$/;
        if (valuePhoneNumber === '' || re.test(valuePhoneNumber)) {
          setDataFindPassword({
            ...dataFindPassword,
            [name]: formatPhoneNumber(valuePhoneNumber),
          });
        }
      }
      return false;
    }

    setDataFindPassword({
      ...dataFindPassword,
      [name]: value,
    });
  };

  const findIDTab = (
    <>
      <div className="input-component">
        <label className="required">이름</label>
        <div className="input-group">
          <input
            type="text"
            placeholder="가입한 이름을 입력해주세요."
            name={'name'}
            onChange={_onChangeInputFindEmail}
            value={dataFindEmail.name}
            autoComplete={'off'}
          />
        </div>
        {errorFindEmail.name ? (
          <span className="input-error show">{'*' + errorFindEmail.name}</span>
        ) : (
          ''
        )}
      </div>
      <div className="input-component ">
        <label className="required">휴대폰번호</label>
        <div className="input-group">
          <input
            type="text"
            className="input-group__input_form"
            placeholder="(-)를 제외하고 입력해주세요. "
            name={'phone'}
            onChange={_onChangeInputFindEmail}
            value={dataFindEmail.phone}
            autoComplete={'off'}
          />
        </div>
        {errorFindEmail.phone ? (
          <span className="input-error show">{'*' + errorFindEmail.phone}</span>
        ) : (
          ''
        )}
      </div>
    </>
  );
  const findPWTab = (
    <>
      <div className="input-component">
        <label className="required">이름</label>
        <div className="input-group">
          <input
            type="text"
            placeholder="가입한 이름을 입력해주세요."
            name={'find_password_name'}
            onChange={_onChangeInputFindPassword}
            value={dataFindPassword.name}
            autoComplete={'off'}
          />
        </div>
        {errorFindPassword.name ? (
          <span className="input-error show">
            {'*' + errorFindPassword.name}
          </span>
        ) : (
          ''
        )}
      </div>
      <div className="input-component">
        <label className="required">휴대폰번호</label>
        <div className="input-group">
          <input
            type="text"
            className="input-group__input_form"
            placeholder="(-)를 제외하고 입력해주세요. "
            name={'find_password_phone'}
            onChange={_onChangeInputFindPassword}
            value={dataFindPassword.phone}
            autoComplete={'off'}
          />
        </div>
        {errorFindPassword.phone ? (
          <span className="input-error show">
            {'*' + errorFindPassword.phone}
          </span>
        ) : (
          ''
        )}
      </div>
      <div className="input-component  mb-0">
        <label className="required">아이디입력</label>
        <div className="input-group">
          <input
            type="text"
            className="input-group__input_form"
            placeholder="아이디를 입력해주세요."
            name={'find_password_email'}
            onChange={_onChangeInputFindPassword}
            value={dataFindPassword.email}
            autoComplete={'off'}
          />
          {errorFindPassword.email ? (
            <span className="input-error show">
              {'*' + errorFindPassword.email}
            </span>
          ) : (
            ''
          )}
        </div>
      </div>
    </>
  );

  const handleSubmitForm = () => {
    setButtonSubmit(false);
    switch (tabIndex) {
      case 0:
        API.post(ROUTES.API_FIND_EMAIL, dataFindEmail)
          .then((res) => {
            setErrorFindEmail({});
            let data = res.data.data;

            let message =
              '회원님의 아이디(이메일)은\n' +
              `<span class="text-email">${data.email}</span>입니다.\n`;

            setDialogNotice({
              show: true,
              content: message,
            });
            setButtonSubmit(true);
            setRedirectToLogin(true);
          })
          .catch((e) => {
            setErrorFindEmail({});
            let dataError = {};
            let errors = e.response;
            setButtonSubmit(true);
            switch (errors?.status) {
              case 422:
                if (errors.data && errors.data.errors) {
                  Object.keys(errors.data.errors).map(function (key, index) {
                    dataError[key] = errors.data.errors[key][0];
                  });
                  setErrorFindEmail(dataError);
                }
                break;
              case 404:
                setDialogNotice({
                  show: true,
                  content:
                    '가입되어 있지 않은 회원 정보입니다.\n' +
                    '다시 확인해주세요.\n',
                });
            }
          });

        break;

      case 1:
        API.post(ROUTES.API_FIND_PASSWORD, dataFindPassword)
          .then((res) => {
            setErrorFindPassword({});
            setButtonSubmit(true);
            let message =
              `<span class="text-email">${dataFindPassword.email}</span> 으로 \n 임시비밀번호를 보내드렸습니다. \n` +
              '로그인 후 비밀번호를 변경해주세요.\n';

            setDialogNotice({
              show: true,
              content: message,
            });

            //to redirect to login
            setRedirectToLogin(true);
          })
          .catch((e) => {
            setErrorFindPassword({});
            setButtonSubmit(true);
            let dataError = {};
            let errors = e.response;
            switch (errors?.status) {
              case 422:
                if (errors.data && errors.data.errors) {
                  Object.keys(errors.data.errors).map(function (key, index) {
                    dataError[key] = errors.data.errors[key][0];
                  });
                  setErrorFindPassword(dataError);
                }
                break;
              case 404:
                setDialogNotice({
                  show: true,
                  content:
                    '가입되어 있지 않은 회원 정보입니다.\n' +
                    '다시 확인해주세요.\n',
                });
            }
          });
        break;
    }
  };

  const _handleCloseDialog = () => {
    setDialogNotice(false);
    if (redirectToLogin) {
      navigate(ROUTERS.LOGIN);
    }
  };

  const handleLabelLeft = () => {
    navigate(ROUTERS.LOGIN);
  };

  const _callAppleForgotId = () => {
		window.callOpenBrowserNative(SOCIAL_LINK.APPLE);
	};

  const _callGoogleForgotId = () => {
		window.callOpenBrowserNative(SOCIAL_LINK.GOOGLE)
	};

  const _callKakaoForgotId = () => {
		if (tabIndex === 0) {
			window.callOpenBrowserNative(SOCIAL_LINK.KAKAO_ID);
		}else{
			window.callOpenBrowserNative(SOCIAL_LINK.KAKAO_PW);
		}
	};

  const _callNaverForgotId = () => {
		if (tabIndex === 0) {
			window.callOpenBrowserNative(SOCIAL_LINK.NAVER_ID);
		}else{
			window.callOpenBrowserNative(SOCIAL_LINK.NAVER_PW);
		}
	};

  return (
    <MainLayout pageID={'forgot-account'} displayBottomNav={false}>
      <HeaderHs2
        title={'아이디 / 비밀번호 찾기'}
        labelLeft={true}
        labelRight={false}
        handleLabelLeft={handleLabelLeft}
      />
      <div className="wrapper">
        <TabsComponent
          tabHeadings={['아이디 찾기', '비밀번호 찾기']}
          tabContents={[findIDTab, findPWTab]}
          tabIndex={tabIndex}
          handleChangeTab={setTabIndex}
        />
        <div className={`forgot-social ${tabIndex === 0 ? 'find-id' : ''}`}>
					<div className="forgot-social__text">
						<label className="line" />
						<br />
						<label className="text-left">간편로그인 아이디 찾기</label>
						<div className='text-content'>
							간편 로그인 사용자는 이용하신 소셜 서비스에서 <br />
							가입정보를 찾아 주시기 바랍니다.
						</div>
						<div className="content-login-social">
							{isIOS ? (
								<div
									className={'social-button'}
									onClick={_callAppleForgotId}
									// disabled={isProcessing}
								>
									{/* <img src="/images/login_apple.svg" alt=""/> */}
                    <LoginApple />
                </div>
							) : (
								''
							)}

							{isIOS || isAndroid ? (
								<>
									<div
										className={'social-button'}
										// disabled={isProcessing}
										onClick={_callNaverForgotId}
									>
										{/* <img src="/images/login_naver.svg" alt="" /> */}
                    <LoginNaver />
                  </div>
									<div
										className={'social-button'}
										onClick={_callKakaoForgotId}
										// disabled={isProcessing}
									>
										{/* <img src="/images/login_kakao.svg" alt="" /> */}
                    <LoginKakao />
                  </div>
									<div
										className={'social-button'}
										onClick={_callGoogleForgotId}
										// disabled={isProcessing}
									>
										{/* <img src="/images/login_gmail.svg" alt="" /> */}
                    <LoginGmail />
                  </div>
								</>
							) : (
								''
							)}
						</div>
					</div>
        </div>
        <div className="btn-forgot">
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleSubmitForm}
            disabled={!buttonSubmit}
          >
            {tabIndex ? '비밀번호 찾기' : '아이디 찾기'}
          </button>
        </div>
      </div>

      {dialogNotice.show && (
        <DialogComponent
          id={'MD3'}
          show={dialogNotice.show}
          title={'알림'}
          closeBtn={'확인'}
          handleClose={_handleCloseDialog}
        >
          {/*{dialogNotice.content}*/}
          <div dangerouslySetInnerHTML={{ __html: dialogNotice.content }} />
        </DialogComponent>
      )}
    </MainLayout>
  );
};

export default ForgotPasswordComponent;
